import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
declare var $: any;
@Component({
  selector: 'app-mbp4blist',
  templateUrl: './mbp4blist.component.html',
  styleUrls: ['./mbp4blist.component.css']
})
export class Mbp4blistComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfDirectorship: DataTables.Settings = {};
  dtTriggerOfDirectorship: Subject<any> = new Subject();
  directorshipArray: any[];
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;
  CessationDate: any;
  AppointmentDate: any;
  response: boolean;
  isSearchDivVisible = false;
  constructor(private directorMasterService: DirectorMasterService, private router: Router, 
    private alert: AlertComponent,private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.environmentSettings = environment;
    let searchflag = localStorage.getItem('searchdireflag');

    this.getMbpList();
    this.dtOptionsOfDirectorship = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [6] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'MBP-04(B) Masters',
          title: 'MBP-04(B) Masters',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3 , 4, 5],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };
  
  
     
     //this.dtTriggerOfDirectorship.next();
  }

  // getMbpList() {
  //   this.directorshipArray = [];
  //   this.directorMasterService.getRegisterDirector().subscribe(directorshipData => {
  //     $("#directorshipTable").DataTable().destroy();
  //     for (var i = 0; i < directorshipData.registerDirectorList.length; i++) {
  //       for (let j = 0; j < directorshipData.registerDirectorList[i].Directorship.length; j++) {
  //         this.directorshipArray.push(directorshipData.registerDirectorList[i].Directorship[j]);
  //         this.dtTriggerOfDirectorship.next();
  //       }

  //     }
  //     this.dtTriggerOfDirectorship.next();

  //   });
  // }


  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  getMbpList() {
    this.directorshipArray = [];
    var searchParam =
    {
      "CessationDate": null,
      "AppointmentDate": null,
      'isSearch': false,
    };
    this.directorMasterService.getMbp4bData(searchParam).subscribe(directorshipData => {
      // $("#directorshipTable").DataTable().destroy();
      this.directorshipArray  = directorshipData.Data;
      console.log(" this.directorshipArray", this.directorshipArray)
      this.dtTriggerOfDirectorship.next();
      // setTimeout(() => {
      //   this.dtTriggerMbp.next();
      // }, 200);
    });
    // this.dtTriggerOfDirectorship.next();
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  doAdvSearch(){
    this.response = true;
    var searchParam =
    {
     
      "CessationDate":this.setDate(this.CessationDate),
      "AppointmentDate":this.setDate(this.AppointmentDate),
      'isSearch': true,
    };
    this.directorshipArray = [];
    $("#directorshipTable").DataTable().destroy();
    this.directorMasterService.getMbp4bData(searchParam).subscribe(directorshipData => {
      this.response = false;
      this.directorshipArray  =directorshipData.Data;
      console.log(" 222222this.directorshipArray", this.directorshipArray)
      this.dtTriggerOfDirectorship.next();
    });
    
  }
  clearAdvSearch(){
   
    this.CessationDate= undefined;
    this.AppointmentDate= undefined;
    $("#directorshipTable").DataTable().destroy();
    this.getMbpList();
    // this.response = false;
   
  }



  generateMbp4bDocument() {
    var object = {
      id: null,
      fromDate: this.CessationDate,
      toDate: this.AppointmentDate
    }
    this.directorMasterService.generateMbp4bDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadMbp4BDocument();
          setTimeout(function () {
            self.downloadMbp4BPdfDocument();
          }, 1000);
        }, 1000);
        // this.downloadMbp4BDocument();
        // this.downloadMbp4BPdfDocument();
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadMbp4BDocument() {
    this.directorMasterService.downloadMbp4bFile(null);
  }
  downloadMbp4BPdfDocument() {
    this.directorMasterService.downloadMbp4bPdfFile(null);
  }

  
}
